// App.jsx
import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./app.css";
import "swiper/css";
import "react-toastify/dist/ReactToastify.css";
import "./i18n";

import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

import { SessionProvider } from "./session/SessionProvider";
import PrivateRoute from "./components/auth/PrivateRoute";
import OrgPrivateRoute from "./components/auth/OrgPrivateRoute";

import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import OrganizationPanel from "./pages/organization/OrganizationPanel";
import OrgUsersPage from "./pages/organization/OrgUsersPage";
import OrgCategoriesPage from "./pages/organization/OrgCategoriesPage";
import OrgExamsPage from "./pages/organization/OrgExamsPage";
import OrgResultsPage from "./pages/organization/OrgResultsPage";
import ExamPreviewPage from "./pages/organization/ExamPreviewPage";
import ExamBuilderPage from "./pages/organization/ExamBuilderPage";
import GradingListPage from "./pages/organization/GradingListPage";
import GradingDetailPage from "./pages/organization/GradingDetailPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import ExamsPage from "./pages/ExamsPage";
import ResultPage from "./pages/ResultPage";
import EducationalResourcePage from "./pages/EducationalResourcePage";
import SupportPage from "./pages/SupportPage";
import SettingsPage from "./pages/SettingsPage";
import ExamLayout from "./pages/ExamLayout";
import ExamResultPage from "./pages/ExamResultPage";
import NotFound from "./pages/NotFound";
import OrgOrganizationsPage from "./pages/organization/OrgOrganizationsPage";
import OrganizationDetailsPage from "./pages/organization/OrganizationDetailsPage";
import TicketDetailPage from "./pages/TicketDetailPage";
import OrgSupportPage from "./pages/organization/OrgSupportPage";
import OrgTicketDetailPage from "./pages/organization/OrgTicketDetailPage";
import OrgResourcesPage from "./pages/organization/OrgResourcesPage";
import AuthMagicLoginPage from "./pages/AuthMagicLoginPage";

const App = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    const dir = i18n.language === "fa" ? "rtl" : "ltr";
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = dir;
  }, [i18n.language]);

  return (
    <SessionProvider>
      <BrowserRouter>
        <ToastContainer
          toastStyle={{
            fontFamily: "IranSans",
            textAlign: "right",
            color: "#000",
          }}
          position="top-center"
        />

        <Routes>
          <Route path="/" element={<LoginPage />} />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/subscription"
            element={
              <PrivateRoute>
                <SubscriptionPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/exams"
            element={
              <PrivateRoute>
                <ExamsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/exam/:examId"
            element={
              <PrivateRoute>
                <ExamLayout />
              </PrivateRoute>
            }
          />
          <Route path="/results/:resultId" element={<ExamResultPage />} />
          <Route
            path="/result"
            element={
              <PrivateRoute>
                <ResultPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/educationalresource"
            element={
              <PrivateRoute>
                <EducationalResourcePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/support"
            element={
              <PrivateRoute>
                <SupportPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/support/:id"
            element={
              <PrivateRoute>
                <TicketDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <SettingsPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/exam/preview/:id"
            element={
              <>
                <ExamPreviewPage />
              </>
            }
          />

          {/* پنل سازمانی: ابتدا گارد سازمان، سپس گاردهای ریز بر اساس پرمیشن */}
          <Route
            path="/organization"
            element={
              <OrgPrivateRoute>
                <OrganizationPanel />
              </OrgPrivateRoute>
            }
          />
          <Route
            path="/organization/users"
            element={
              <OrgPrivateRoute>
                <OrgUsersPage />
              </OrgPrivateRoute>
            }
          />
          <Route
            path="/organization/organizations"
            element={
              <OrgPrivateRoute>
                <OrgOrganizationsPage />
              </OrgPrivateRoute>
            }
          />
          <Route
            path="/organization/organizations/:id"
            element={
              <OrgPrivateRoute>
                <OrganizationDetailsPage />
              </OrgPrivateRoute>
            }
          />
          <Route
            path="/organization/support"
            element={
              <OrgPrivateRoute>
                <OrgSupportPage />
              </OrgPrivateRoute>
            }
          />
            <Route
            path="/organization/resource"
            element={
              <OrgPrivateRoute>
                <OrgResourcesPage />
              </OrgPrivateRoute>
            }
          />
          <Route
            path="/organization/support/:id"
            element={
              <OrgPrivateRoute>
                <OrgTicketDetailPage />
              </OrgPrivateRoute>
            }
          />
          <Route
            path="/organization/categories"
            element={
              <OrgPrivateRoute>
                <OrgCategoriesPage />
              </OrgPrivateRoute>
            }
          />
          <Route
            path="/organization/exams"
            element={
              <OrgPrivateRoute>
                <OrgExamsPage />
              </OrgPrivateRoute>
            }
          />

          <Route
            path="/organization/exam-builder"
            element={
              <OrgPrivateRoute>
                <ExamBuilderPage />
              </OrgPrivateRoute>
            }
          />
          <Route
            path="/organization/results"
            element={
              <OrgPrivateRoute>
                <OrgResultsPage />
              </OrgPrivateRoute>
            }
          />
          <Route
            path="/organization/grading"
            element={
              <OrgPrivateRoute>
                <GradingListPage />
              </OrgPrivateRoute>
            }
          />
          <Route
            path="/organization/grading/:attemptId"
            element={
              <OrgPrivateRoute>
                <GradingDetailPage />
              </OrgPrivateRoute>
            }
          />
          <Route path="/auth/magic" element={<AuthMagicLoginPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </SessionProvider>
  );
};

export default App;
